/**
 * The tenant's content-language registry (BFF: `/api/v1/catalog/languages`).
 *
 * The SAME resource `features/catalog`'s `useCatalogLanguages` reads (`CatalogLanguagesPage`) —
 * duplicated here as its own call rather than a cross-feature import, per FSD (features do not
 * import each other's internals; only the public re-export surface of a designated "shared-like"
 * feature such as `store-settings` is consumed cross-feature in this codebase — `features/catalog`
 * is not one). design-chatbot-templates-page.md A3/Q2.
 */
import { apiClient } from '@/shared/api';
import type { ContentLanguage } from '../model/types';

const BASE = '/api/v1/catalog/languages';

export const listContentLanguages = async (): Promise<ContentLanguage[]> =>
  (await apiClient.get<ContentLanguage[]>(BASE)).data;
